<template>
	<div
		class="tags-row"
		v-if="tags"
	>
		<div
			v-for="(tag, index) in tags"
			:key="index"
			class="tag"
			:class="[{ 'premium': isTagPremium(tag), 'change-color': tag.color }]"
			:style="tag.color ? `--color: ${tag.color}` : null"	
			v-if="!isTagElectrolux(tag)"
		>
			<span	
				v-html="tag.name"
			/>
		</div>	
	</div>
</template>

<script type="text/javascript">

import { configStore } from '../../store/configStore' 

export default {
	data () {
		return {
			configStore: configStore.state
		}
	},

	props: {
		items: {
			type: Array,
			default () {
				return null
			}
		}
	},

	computed: {	
		tags () {
			return this.items.map(r => {
				if (typeof r === 'object') return r
				return { name: r, color: null }
			})
		},

		tagPremium () {
			return this.configStore.config && this.configStore.config['quomi.tags.premium_tag']
				? this.configStore.config['quomi.tags.premium_tag'].toLocaleLowerCase()
				: this.configStore.default.premium_tag.toLocaleLowerCase()
		}
	},

	methods: {
		isTagElectrolux (tag) {
			return tag.name.toLocaleLowerCase().includes(`electrolux`)
		},

		isTagPremium (tag) {
			return tag.name.toLocaleLowerCase() === this.tagPremium 
		}
		
	},

	mounted () {
		configStore.loadConfig()
	}
}
</script>

<style scoped>

	.tags-row > .tag {
		text-transform: uppercase;
		display: inline-block;
		background: orange;
		color: white;
		font-weight: bold;
		border-radius: 6px;
		padding: 0px 5px;
		margin-right: 10px;
		margin-top: 2px;
		z-index: 2;
    font-size: 11px;
	}

	.tags-row > .tag.premium {
		background-color: #E5C100;
	}

	.tags-row > .tag.change-color {
		background-color: var(--color);
		/*background-color: var(--quomi-blue);*/
	}

	.tags-row .tag {
		border: 1.5px solid white;
		margin-right: 5px;
		margin-top: 2px;
		width: max-content;
	}

	.logo {
		padding: 2px 0;
		height: 18px;
		margin-bottom: 1px;
	}

	@media(max-width: 640px) {
		.tags-row > .tag {
			font-size: 50%;
			width: max-content;
		}
	}
</style>
